import React from "react";


const status2IconClass: {
  [status: string]: { iClass: string; addClass?: string };
} = {
  setup: {
    iClass: "fal fa-cog status",
  },
  inprogress: {
    iClass: "fal fa-hourglass-start status",
  },

  assist: {
    iClass: "fal fa-user-headset status",
  },

  failed: {
    iClass: "fal fa-exclamation-circle error status",
    addClass: "error",
  },

  success: {
    iClass: "fal fa-check-circle success status",
    addClass: "success",
  },

  reviewed: {
    iClass: "fas fa-clipboard-check success status",
    addClass: "reviewed",
  },

  verified: {
    iClass: "fas fa-check-double success status",
    addClass: "verified",
  },

  sent: {
    iClass: "fas fa-envelope status",
    addClass: "sent",
  },

  approved: {
    iClass: "fal fa-thumbs-up success status",
    addClass: "success",
  },

  certified: {
    iClass: "fal fa-shield-alt status",
    addClass: "success",
  },
};

interface SessionStatusProps {
  status: string;
  name: string;
  iconOnly: boolean;
}

const SessionStatus: React.FC<SessionStatusProps> = ({
  status,
  name,
  iconOnly = false,
}) => {
  const s = status.toLocaleLowerCase();

  const icon = (
    <i
      className={`${status2IconClass[s]?.iClass ?? ""} ${
        status2IconClass[s]?.addClass
      }`}
    ></i>
  );
  return iconOnly ? (
    icon
  ) : (
    <span className="sessionStatusLine">
      {icon} {name}
    </span>
  );
};

export default SessionStatus;
